import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { COOKIE_KEYS } from "@/shared/constants/cookies.const";

export function useAuth() {
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedToken = Cookies.get(COOKIE_KEYS.token) || null;
    setToken(storedToken);
    setIsLoading(false);
  }, []);

  return {
    token,
    isAuthenticated: Boolean(token),
    isLoading,
  };
}
